export default {
  TableHead: [
    [
      {
        displayName: 'report.depositWithdraw.datatable.number',
      },
      {
        displayName: 'report.depositWithdraw.datatable.username',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'report.depositWithdraw.datatable.currency',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'report.depositWithdraw.datatable.detail',
      },
      {
        displayName: 'report.depositWithdraw.datatable.total_deposit',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.depositWithdraw.datatable.total_withdraw',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.depositWithdraw.datatable.balance',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.depositWithdraw.datatable.total_auto_deposit',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.depositWithdraw.datatable.total_auto_withdraw',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.depositWithdraw.datatable.balance',
        attr: {
          class: 'text-right',
        },
      },
    ],
  ],
  TableHeadDetail: [
    [
      {
        displayName: 'report.depositWithdraw.datatable.number',
      },
      {
        displayName: 'report.depositWithdraw.datatable.username',
      },
      {
        displayName: 'report.depositWithdraw.datatable.date',
      },
      {
        displayName: 'report.depositWithdraw.datatable.action',
      },
      {
        displayName: 'report.depositWithdraw.datatable.relate_user',
      },
      {
        displayName: 'report.depositWithdraw.datatable.currency',
      },
      {
        displayName: 'report.depositWithdraw.datatable.amount',
      },
      {
        displayName: 'report.depositWithdraw.datatable.relate_user',
      },
      {
        displayName: 'report.depositWithdraw.datatable.request',
      },
      {
        displayName: 'report.depositWithdraw.datatable.ip_address',
        isAdmin: true,
      },
    ],
  ],
};
